import { authApiService } from '@/api/authApiService';
import { ApiResponseType, AuthResponseType } from '@/types/sharedTypes';

export type SendOtpCodePayloadType = {
  code: string;
};

export const sendOtpCodeApi = async (data: SendOtpCodePayloadType): Promise<ApiResponseType<AuthResponseType>> => {
  const uri = `/users/auth/otp/`;

  return authApiService.POST(uri, data);
};
